/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.3.0 (NJsonSchema v10.1.26.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const BaseApiUrl = new InjectionToken<string>('BaseApiUrl');

@Injectable()
export class AccountingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    accounting(): Observable<Accounting[]> {
        let url_ = this.baseUrl + "/api/Accounting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccounting(<any>response_);
                } catch (e) {
                    return <Observable<Accounting[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Accounting[]>><any>_observableThrow(response_);
        }));
    }

    protected processAccounting(response: HttpResponseBase): Observable<Accounting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Accounting.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Accounting[]>(<any>null);
    }

    /**
     * @return Success
     */
    byId(accountingId: number): Observable<Accounting> {
        let url_ = this.baseUrl + "/api/Accounting/ById/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processById(<any>response_);
                } catch (e) {
                    return <Observable<Accounting>><any>_observableThrow(e);
                }
            } else
                return <Observable<Accounting>><any>_observableThrow(response_);
        }));
    }

    protected processById(response: HttpResponseBase): Observable<Accounting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Accounting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Accounting>(<any>null);
    }

    /**
     * @return Success
     */
    byAccountingId(accountingId: number): Observable<AccountingDetailDto> {
        let url_ = this.baseUrl + "/api/Accounting/ByAccountingId/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByAccountingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByAccountingId(<any>response_);
                } catch (e) {
                    return <Observable<AccountingDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountingDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processByAccountingId(response: HttpResponseBase): Observable<AccountingDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountingDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountingDetailDto>(<any>null);
    }

    /**
     * @return Success
     */
    dashboardByAccountingId(accountingId: number): Observable<DashboardDto> {
        let url_ = this.baseUrl + "/api/Accounting/dashboardByAccountingId/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardByAccountingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardByAccountingId(<any>response_);
                } catch (e) {
                    return <Observable<DashboardDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardDto>><any>_observableThrow(response_);
        }));
    }

    protected processDashboardByAccountingId(response: HttpResponseBase): Observable<DashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardDto>(<any>null);
    }
}

@Injectable()
export class ApplicationUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    commercials(): Observable<any[]> {
        let url_ = this.baseUrl + "/api/ApplicationUser/Commercials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommercials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommercials(<any>response_);
                } catch (e) {
                    return <Observable<any[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<any[]>><any>_observableThrow(response_);
        }));
    }

    protected processCommercials(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any[]>(<any>null);
    }

    /**
     * @return Success
     */
    profile(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/ApplicationUser/Profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ApplicationUser/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CurrencyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    currency(): Observable<Currency[]> {
        let url_ = this.baseUrl + "/api/Currency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrency(<any>response_);
                } catch (e) {
                    return <Observable<Currency[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Currency[]>><any>_observableThrow(response_);
        }));
    }

    protected processCurrency(response: HttpResponseBase): Observable<Currency[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Currency.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Currency[]>(<any>null);
    }
}

@Injectable()
export class CustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    revenueByCustomerId(customerId: number, accountingId: number): Observable<CustomerRevenue> {
        let url_ = this.baseUrl + "/api/Customer/RevenueByCustomerId/{customerId}/{accountingId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevenueByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevenueByCustomerId(<any>response_);
                } catch (e) {
                    return <Observable<CustomerRevenue>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerRevenue>><any>_observableThrow(response_);
        }));
    }

    protected processRevenueByCustomerId(response: HttpResponseBase): Observable<CustomerRevenue> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRevenue.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerRevenue>(<any>null);
    }

    /**
     * @return Success
     */
    customerGet(): Observable<Customer[]> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGet(<any>response_);
                } catch (e) {
                    return <Observable<Customer[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerGet(response: HttpResponseBase): Observable<Customer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Customer.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerPost(body: Customer | undefined): Observable<Customer> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerPost(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerPost(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerPut(body: Customer | undefined): Observable<Customer> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerPut(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerPut(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: FilterDto | undefined): Observable<CustomerPaginatedDto> {
        let url_ = this.baseUrl + "/api/Customer/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<CustomerPaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerPaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<CustomerPaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPaginatedDto>(<any>null);
    }

    /**
     * @return Success
     */
    byCompanyName(companyName: string): Observable<Customer[]> {
        let url_ = this.baseUrl + "/api/Customer/ByCompanyName/{companyName}";
        if (companyName === undefined || companyName === null)
            throw new Error("The parameter 'companyName' must be defined.");
        url_ = url_.replace("{companyName}", encodeURIComponent("" + companyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByCompanyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByCompanyName(<any>response_);
                } catch (e) {
                    return <Observable<Customer[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer[]>><any>_observableThrow(response_);
        }));
    }

    protected processByCompanyName(response: HttpResponseBase): Observable<Customer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Customer.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCustomer(customerId: number): Observable<Customer> {
        let url_ = this.baseUrl + "/api/Customer/GetCustomer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }
}

@Injectable()
export class DeliveryInvoiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    pdf(deliveryInvoiceIdentifier: string): Observable<void> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice/Pdf/{deliveryInvoiceIdentifier}";
        if (deliveryInvoiceIdentifier === undefined || deliveryInvoiceIdentifier === null)
            throw new Error("The parameter 'deliveryInvoiceIdentifier' must be defined.");
        url_ = url_.replace("{deliveryInvoiceIdentifier}", encodeURIComponent("" + deliveryInvoiceIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPdf(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(accountingId: number, body: DeliveryInvoiceFilter | undefined): Observable<SmallDeliveryInvoiceDtoPaginatedDto> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice/Search/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<SmallDeliveryInvoiceDtoPaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SmallDeliveryInvoiceDtoPaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SmallDeliveryInvoiceDtoPaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmallDeliveryInvoiceDtoPaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmallDeliveryInvoiceDtoPaginatedDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customDeliveryInvoiceNumber(body: KeyParameter | undefined): Observable<DeliveryInvoice> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice/CustomDeliveryInvoiceNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomDeliveryInvoiceNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDeliveryInvoiceNumber(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoice>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoice>><any>_observableThrow(response_);
        }));
    }

    protected processCustomDeliveryInvoiceNumber(response: HttpResponseBase): Observable<DeliveryInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryInvoice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoice>(<any>null);
    }

    /**
     * @return Success
     */
    deliveryInvoiceGet(deliveryInvoiceId: number): Observable<DeliveryInvoiceDto> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice/{deliveryInvoiceId}";
        if (deliveryInvoiceId === undefined || deliveryInvoiceId === null)
            throw new Error("The parameter 'deliveryInvoiceId' must be defined.");
        url_ = url_.replace("{deliveryInvoiceId}", encodeURIComponent("" + deliveryInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryInvoiceGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryInvoiceGet(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryInvoiceGet(response: HttpResponseBase): Observable<DeliveryInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoiceDto>(<any>null);
    }

    /**
     * @return Success
     */
    edit(deliveryInvoiceId: number): Observable<CrudDeliveryInvoiceDto> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice/Edit/{deliveryInvoiceId}";
        if (deliveryInvoiceId === undefined || deliveryInvoiceId === null)
            throw new Error("The parameter 'deliveryInvoiceId' must be defined.");
        url_ = url_.replace("{deliveryInvoiceId}", encodeURIComponent("" + deliveryInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<CrudDeliveryInvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CrudDeliveryInvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<CrudDeliveryInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrudDeliveryInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CrudDeliveryInvoiceDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryInvoicePost(body: CrudDeliveryInvoiceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryInvoicePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryInvoicePost(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryInvoicePost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryInvoicePut(body: CrudDeliveryInvoiceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryInvoicePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryInvoicePut(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryInvoicePut(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    sign(deliveryInvoiceId: number): Observable<DeliveryInvoice> {
        let url_ = this.baseUrl + "/api/DeliveryInvoice/sign/{deliveryInvoiceId}";
        if (deliveryInvoiceId === undefined || deliveryInvoiceId === null)
            throw new Error("The parameter 'deliveryInvoiceId' must be defined.");
        url_ = url_.replace("{deliveryInvoiceId}", encodeURIComponent("" + deliveryInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSign(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoice>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoice>><any>_observableThrow(response_);
        }));
    }

    protected processSign(response: HttpResponseBase): Observable<DeliveryInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryInvoice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoice>(<any>null);
    }
}

@Injectable()
export class DeliveryInvoicePaymentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deliveryInvoicePaymentDelete(deliveryInvoicePaymentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DeliveryInvoicePayment/{deliveryInvoicePaymentId}";
        if (deliveryInvoicePaymentId === undefined || deliveryInvoicePaymentId === null)
            throw new Error("The parameter 'deliveryInvoicePaymentId' must be defined.");
        url_ = url_.replace("{deliveryInvoicePaymentId}", encodeURIComponent("" + deliveryInvoicePaymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryInvoicePaymentDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryInvoicePaymentDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryInvoicePaymentDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    byDeliveryInvoiceId(deliveryInvoiceId: number): Observable<DeliveryInvoicePayment[]> {
        let url_ = this.baseUrl + "/api/DeliveryInvoicePayment/ByDeliveryInvoiceId/{deliveryInvoiceId}";
        if (deliveryInvoiceId === undefined || deliveryInvoiceId === null)
            throw new Error("The parameter 'deliveryInvoiceId' must be defined.");
        url_ = url_.replace("{deliveryInvoiceId}", encodeURIComponent("" + deliveryInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByDeliveryInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByDeliveryInvoiceId(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoicePayment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoicePayment[]>><any>_observableThrow(response_);
        }));
    }

    protected processByDeliveryInvoiceId(response: HttpResponseBase): Observable<DeliveryInvoicePayment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryInvoicePayment.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoicePayment[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryInvoicePaymentPost(body: DeliveryInvoicePayment | undefined): Observable<DeliveryInvoicePayment> {
        let url_ = this.baseUrl + "/api/DeliveryInvoicePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryInvoicePaymentPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryInvoicePaymentPost(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoicePayment>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoicePayment>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryInvoicePaymentPost(response: HttpResponseBase): Observable<DeliveryInvoicePayment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryInvoicePayment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoicePayment>(<any>null);
    }
}

@Injectable()
export class DeliveryInvoiceProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deliveryInvoiceProduct(): Observable<DeliveryInvoiceProduct[]> {
        let url_ = this.baseUrl + "/api/DeliveryInvoiceProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryInvoiceProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryInvoiceProduct(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoiceProduct[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoiceProduct[]>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryInvoiceProduct(response: HttpResponseBase): Observable<DeliveryInvoiceProduct[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryInvoiceProduct.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoiceProduct[]>(<any>null);
    }

    /**
     * @return Success
     */
    byDeliveryInvoice(deliveryInvoiceId: number): Observable<DeliveryInvoiceProduct[]> {
        let url_ = this.baseUrl + "/api/DeliveryInvoiceProduct/ByDeliveryInvoice/{deliveryInvoiceId}";
        if (deliveryInvoiceId === undefined || deliveryInvoiceId === null)
            throw new Error("The parameter 'deliveryInvoiceId' must be defined.");
        url_ = url_.replace("{deliveryInvoiceId}", encodeURIComponent("" + deliveryInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByDeliveryInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByDeliveryInvoice(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryInvoiceProduct[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryInvoiceProduct[]>><any>_observableThrow(response_);
        }));
    }

    protected processByDeliveryInvoice(response: HttpResponseBase): Observable<DeliveryInvoiceProduct[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryInvoiceProduct.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryInvoiceProduct[]>(<any>null);
    }
}

@Injectable()
export class ExpenseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    allExpenseKind(): Observable<ExpenseKindDto[]> {
        let url_ = this.baseUrl + "/api/Expense/AllExpenseKind";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllExpenseKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllExpenseKind(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseKindDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseKindDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAllExpenseKind(response: HttpResponseBase): Observable<ExpenseKindDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseKindDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseKindDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ExpenseDto | undefined): Observable<ExpenseDto> {
        let url_ = this.baseUrl + "/api/Expense/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ExpenseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filter(accountingId: number, body: ExpenseFilterDto | undefined): Observable<ExpenseDtoExpensePaginatedDto> {
        let url_ = this.baseUrl + "/api/Expense/Filter/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseDtoExpensePaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseDtoExpensePaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processFilter(response: HttpResponseBase): Observable<ExpenseDtoExpensePaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseDtoExpensePaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseDtoExpensePaginatedDto>(<any>null);
    }

    /**
     * @return Success
     */
    getById(expenseId: number): Observable<ExpenseDto> {
        let url_ = this.baseUrl + "/api/Expense/GetById/{expenseId}";
        if (expenseId === undefined || expenseId === null)
            throw new Error("The parameter 'expenseId' must be defined.");
        url_ = url_.replace("{expenseId}", encodeURIComponent("" + expenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ExpenseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseDto>(<any>null);
    }

    /**
     * @return Success
     */
    expense(expenseId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Expense/{expenseId}";
        if (expenseId === undefined || expenseId === null)
            throw new Error("The parameter 'expenseId' must be defined.");
        url_ = url_.replace("{expenseId}", encodeURIComponent("" + expenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpense(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExpense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ExpenseDto[]> {
        let url_ = this.baseUrl + "/api/Expense/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ExpenseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseDto[]>(<any>null);
    }
}

@Injectable()
export class FurnisherService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    furnisherGet(): Observable<Furnisher[]> {
        let url_ = this.baseUrl + "/api/Furnisher";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnisherGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnisherGet(<any>response_);
                } catch (e) {
                    return <Observable<Furnisher[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Furnisher[]>><any>_observableThrow(response_);
        }));
    }

    protected processFurnisherGet(response: HttpResponseBase): Observable<Furnisher[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Furnisher.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Furnisher[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnisherPost(body: Furnisher | undefined): Observable<Furnisher> {
        let url_ = this.baseUrl + "/api/Furnisher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnisherPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnisherPost(<any>response_);
                } catch (e) {
                    return <Observable<Furnisher>><any>_observableThrow(e);
                }
            } else
                return <Observable<Furnisher>><any>_observableThrow(response_);
        }));
    }

    protected processFurnisherPost(response: HttpResponseBase): Observable<Furnisher> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Furnisher.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Furnisher>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnisherPut(body: Furnisher | undefined): Observable<Furnisher> {
        let url_ = this.baseUrl + "/api/Furnisher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnisherPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnisherPut(<any>response_);
                } catch (e) {
                    return <Observable<Furnisher>><any>_observableThrow(e);
                }
            } else
                return <Observable<Furnisher>><any>_observableThrow(response_);
        }));
    }

    protected processFurnisherPut(response: HttpResponseBase): Observable<Furnisher> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Furnisher.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Furnisher>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: FilterDto | undefined): Observable<FurnisherPaginatedDto> {
        let url_ = this.baseUrl + "/api/Furnisher/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<FurnisherPaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FurnisherPaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FurnisherPaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherPaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnisherPaginatedDto>(<any>null);
    }

    /**
     * @return Success
     */
    byCompanyName(companyName: string): Observable<Furnisher[]> {
        let url_ = this.baseUrl + "/api/Furnisher/ByCompanyName/{companyName}";
        if (companyName === undefined || companyName === null)
            throw new Error("The parameter 'companyName' must be defined.");
        url_ = url_.replace("{companyName}", encodeURIComponent("" + companyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByCompanyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByCompanyName(<any>response_);
                } catch (e) {
                    return <Observable<Furnisher[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Furnisher[]>><any>_observableThrow(response_);
        }));
    }

    protected processByCompanyName(response: HttpResponseBase): Observable<Furnisher[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Furnisher.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Furnisher[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFurnisher(furnisherId: number): Observable<Furnisher> {
        let url_ = this.baseUrl + "/api/Furnisher/GetFurnisher/{furnisherId}";
        if (furnisherId === undefined || furnisherId === null)
            throw new Error("The parameter 'furnisherId' must be defined.");
        url_ = url_.replace("{furnisherId}", encodeURIComponent("" + furnisherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFurnisher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFurnisher(<any>response_);
                } catch (e) {
                    return <Observable<Furnisher>><any>_observableThrow(e);
                }
            } else
                return <Observable<Furnisher>><any>_observableThrow(response_);
        }));
    }

    protected processGetFurnisher(response: HttpResponseBase): Observable<Furnisher> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Furnisher.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Furnisher>(<any>null);
    }
}

@Injectable()
export class FurnisherInvoiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    furnisherInvoiceGet(furnisherInvoiceId: number): Observable<FurnisherInvoiceDto> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice/{furnisherInvoiceId}";
        if (furnisherInvoiceId === undefined || furnisherInvoiceId === null)
            throw new Error("The parameter 'furnisherInvoiceId' must be defined.");
        url_ = url_.replace("{furnisherInvoiceId}", encodeURIComponent("" + furnisherInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnisherInvoiceGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnisherInvoiceGet(<any>response_);
                } catch (e) {
                    return <Observable<FurnisherInvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FurnisherInvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processFurnisherInvoiceGet(response: HttpResponseBase): Observable<FurnisherInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnisherInvoiceDto>(<any>null);
    }

    /**
     * @return Success
     */
    totalAmountSignedOrders(accountingId: number): Observable<AmountDashboardDto> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice/TotalAmountSignedOrders/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalAmountSignedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalAmountSignedOrders(<any>response_);
                } catch (e) {
                    return <Observable<AmountDashboardDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AmountDashboardDto>><any>_observableThrow(response_);
        }));
    }

    protected processTotalAmountSignedOrders(response: HttpResponseBase): Observable<AmountDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AmountDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AmountDashboardDto>(<any>null);
    }

    /**
     * @return Success
     */
    byAccountingId(accountingId: number): Observable<FurnisherInvoice[]> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice/ByAccountingId/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByAccountingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByAccountingId(<any>response_);
                } catch (e) {
                    return <Observable<FurnisherInvoice[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FurnisherInvoice[]>><any>_observableThrow(response_);
        }));
    }

    protected processByAccountingId(response: HttpResponseBase): Observable<FurnisherInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FurnisherInvoice.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnisherInvoice[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(accountingId: number, body: FurnisherInvoiceFilterDto | undefined): Observable<FurnisherInvoiceDtoPaginatedDto> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice/Search/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<FurnisherInvoiceDtoPaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FurnisherInvoiceDtoPaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FurnisherInvoiceDtoPaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherInvoiceDtoPaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnisherInvoiceDtoPaginatedDto>(<any>null);
    }

    /**
     * @return Success
     */
    edit(furnisherInvoiceId: number): Observable<CrudFurnisherInvoiceDto> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice/Edit/{furnisherInvoiceId}";
        if (furnisherInvoiceId === undefined || furnisherInvoiceId === null)
            throw new Error("The parameter 'furnisherInvoiceId' must be defined.");
        url_ = url_.replace("{furnisherInvoiceId}", encodeURIComponent("" + furnisherInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<CrudFurnisherInvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CrudFurnisherInvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<CrudFurnisherInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrudFurnisherInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CrudFurnisherInvoiceDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnisherInvoicePost(body: CrudFurnisherInvoiceDto | undefined): Observable<FurnisherInvoiceDto> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnisherInvoicePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnisherInvoicePost(<any>response_);
                } catch (e) {
                    return <Observable<FurnisherInvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FurnisherInvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processFurnisherInvoicePost(response: HttpResponseBase): Observable<FurnisherInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnisherInvoiceDto>(<any>null);
    }

    /**
     * @return Success
     */
    sign(furnisherInvoiceId: number): Observable<FurnisherInvoice> {
        let url_ = this.baseUrl + "/api/FurnisherInvoice/sign/{furnisherInvoiceId}";
        if (furnisherInvoiceId === undefined || furnisherInvoiceId === null)
            throw new Error("The parameter 'furnisherInvoiceId' must be defined.");
        url_ = url_.replace("{furnisherInvoiceId}", encodeURIComponent("" + furnisherInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSign(<any>response_);
                } catch (e) {
                    return <Observable<FurnisherInvoice>><any>_observableThrow(e);
                }
            } else
                return <Observable<FurnisherInvoice>><any>_observableThrow(response_);
        }));
    }

    protected processSign(response: HttpResponseBase): Observable<FurnisherInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherInvoice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnisherInvoice>(<any>null);
    }
}

@Injectable()
export class InvoicePaymentStatusService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    invoicePaymentStatus(): Observable<InvoicePaymentStatus[]> {
        let url_ = this.baseUrl + "/api/InvoicePaymentStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoicePaymentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoicePaymentStatus(<any>response_);
                } catch (e) {
                    return <Observable<InvoicePaymentStatus[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoicePaymentStatus[]>><any>_observableThrow(response_);
        }));
    }

    protected processInvoicePaymentStatus(response: HttpResponseBase): Observable<InvoicePaymentStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoicePaymentStatus.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoicePaymentStatus[]>(<any>null);
    }
}

@Injectable()
export class InvoiceStatusService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    invoiceStatus(): Observable<InvoiceStatus[]> {
        let url_ = this.baseUrl + "/api/InvoiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceStatus(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceStatus[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceStatus[]>><any>_observableThrow(response_);
        }));
    }

    protected processInvoiceStatus(response: HttpResponseBase): Observable<InvoiceStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceStatus.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceStatus[]>(<any>null);
    }
}

@Injectable()
export class PaymentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Payment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(accountingId: number, body: PaymentFilterDto | undefined): Observable<PaymentDtoPaginatedDto> {
        let url_ = this.baseUrl + "/api/Payment/Search/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PaymentDtoPaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentDtoPaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PaymentDtoPaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentDtoPaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentDtoPaginatedDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PaymentDto | undefined): Observable<PaymentDto> {
        let url_ = this.baseUrl + "/api/Payment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(paymentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Payment/Delete/{paymentId}";
        if (paymentId === undefined || paymentId === null)
            throw new Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PaymentTermService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    paymentTerm(): Observable<PaymentTerm[]> {
        let url_ = this.baseUrl + "/api/PaymentTerm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentTerm(<any>response_);
                } catch (e) {
                    return <Observable<PaymentTerm[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentTerm[]>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentTerm(response: HttpResponseBase): Observable<PaymentTerm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentTerm.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentTerm[]>(<any>null);
    }
}

@Injectable()
export class ProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    byAccountingId(accountingId: number): Observable<SmallProductDto[]> {
        let url_ = this.baseUrl + "/api/Product/ByAccountingId/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByAccountingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByAccountingId(<any>response_);
                } catch (e) {
                    return <Observable<SmallProductDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SmallProductDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processByAccountingId(response: HttpResponseBase): Observable<SmallProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SmallProductDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmallProductDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: FilterDto | undefined): Observable<SmallProductDtoPaginatedDto> {
        let url_ = this.baseUrl + "/api/Product/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<SmallProductDtoPaginatedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SmallProductDtoPaginatedDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SmallProductDtoPaginatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmallProductDtoPaginatedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmallProductDtoPaginatedDto>(<any>null);
    }

    /**
     * @return Success
     */
    byId(productId: number): Observable<SmallProductDto> {
        let url_ = this.baseUrl + "/api/Product/ById/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processById(<any>response_);
                } catch (e) {
                    return <Observable<SmallProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SmallProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processById(response: HttpResponseBase): Observable<SmallProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmallProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmallProductDto>(<any>null);
    }

    /**
     * @return Success
     */
    byName(productName: string): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/Product/ByName/{productName}";
        if (productName === undefined || productName === null)
            throw new Error("The parameter 'productName' must be defined.");
        url_ = url_.replace("{productName}", encodeURIComponent("" + productName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByName(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processByName(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    productPost(body: Product | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductPost(<any>response_);
                } catch (e) {
                    return <Observable<Product>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product>><any>_observableThrow(response_);
        }));
    }

    protected processProductPost(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    productPut(body: Product | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductPut(<any>response_);
                } catch (e) {
                    return <Observable<Product>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product>><any>_observableThrow(response_);
        }));
    }

    protected processProductPut(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(<any>null);
    }
}

@Injectable()
export class ProductCategoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    productCategory(): Observable<ProductCategory[]> {
        let url_ = this.baseUrl + "/api/ProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductCategory(<any>response_);
                } catch (e) {
                    return <Observable<ProductCategory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductCategory[]>><any>_observableThrow(response_);
        }));
    }

    protected processProductCategory(response: HttpResponseBase): Observable<ProductCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductCategory.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductCategory[]>(<any>null);
    }
}

@Injectable()
export class StockService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    byAccountingId(accountingId: number): Observable<StockDto[]> {
        let url_ = this.baseUrl + "/api/Stock/ByAccountingId/{accountingId}";
        if (accountingId === undefined || accountingId === null)
            throw new Error("The parameter 'accountingId' must be defined.");
        url_ = url_.replace("{accountingId}", encodeURIComponent("" + accountingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByAccountingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByAccountingId(<any>response_);
                } catch (e) {
                    return <Observable<StockDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processByAccountingId(response: HttpResponseBase): Observable<StockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDto[]>(<any>null);
    }
}

export class AccountingDetail implements IAccountingDetail {
    accountingDetailId?: number;
    accountingId?: number;
    percentageVat?: number;
    percentageCashTax?: number;
    startPeriod?: Date;
    endPeriod?: Date;
    accountingDetailNavigation?: Accounting | undefined;

    constructor(data?: IAccountingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingDetailId = _data["accountingDetailId"];
            this.accountingId = _data["accountingId"];
            this.percentageVat = _data["percentageVat"];
            this.percentageCashTax = _data["percentageCashTax"];
            this.startPeriod = _data["startPeriod"] ? new Date(_data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
            this.accountingDetailNavigation = _data["accountingDetailNavigation"] ? Accounting.fromJS(_data["accountingDetailNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountingDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingDetailId"] = this.accountingDetailId;
        data["accountingId"] = this.accountingId;
        data["percentageVat"] = this.percentageVat;
        data["percentageCashTax"] = this.percentageCashTax;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["accountingDetailNavigation"] = this.accountingDetailNavigation ? this.accountingDetailNavigation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAccountingDetail {
    accountingDetailId?: number;
    accountingId?: number;
    percentageVat?: number;
    percentageCashTax?: number;
    startPeriod?: Date;
    endPeriod?: Date;
    accountingDetailNavigation?: Accounting | undefined;
}

export class DeliveryInvoicePayment implements IDeliveryInvoicePayment {
    deliveryInvoiceId?: number;
    paymentDate?: Date;
    paymentTermId?: number;
    amount?: number;
    isDeleted?: boolean;
    deliveryInvoicePaymentId?: number;
    deliveryInvoice?: DeliveryInvoice | undefined;
    paymentTerm?: PaymentTerm | undefined;

    constructor(data?: IDeliveryInvoicePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentTermId = _data["paymentTermId"];
            this.amount = _data["amount"];
            this.isDeleted = _data["isDeleted"];
            this.deliveryInvoicePaymentId = _data["deliveryInvoicePaymentId"];
            this.deliveryInvoice = _data["deliveryInvoice"] ? DeliveryInvoice.fromJS(_data["deliveryInvoice"]) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"] ? PaymentTerm.fromJS(_data["paymentTerm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryInvoicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryInvoicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTermId"] = this.paymentTermId;
        data["amount"] = this.amount;
        data["isDeleted"] = this.isDeleted;
        data["deliveryInvoicePaymentId"] = this.deliveryInvoicePaymentId;
        data["deliveryInvoice"] = this.deliveryInvoice ? this.deliveryInvoice.toJSON() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeliveryInvoicePayment {
    deliveryInvoiceId?: number;
    paymentDate?: Date;
    paymentTermId?: number;
    amount?: number;
    isDeleted?: boolean;
    deliveryInvoicePaymentId?: number;
    deliveryInvoice?: DeliveryInvoice | undefined;
    paymentTerm?: PaymentTerm | undefined;
}

export class PaymentTerm implements IPaymentTerm {
    paymentTermId?: number;
    name?: string | undefined;
    label?: string | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
    deliveryInvoicePayment?: DeliveryInvoicePayment[] | undefined;
    payment?: Payment[] | undefined;

    constructor(data?: IPaymentTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentTermId = _data["paymentTermId"];
            this.name = _data["name"];
            this.label = _data["label"];
            if (Array.isArray(_data["deliveryInvoice"])) {
                this.deliveryInvoice = [] as any;
                for (let item of _data["deliveryInvoice"])
                    this.deliveryInvoice!.push(DeliveryInvoice.fromJS(item));
            }
            if (Array.isArray(_data["deliveryInvoicePayment"])) {
                this.deliveryInvoicePayment = [] as any;
                for (let item of _data["deliveryInvoicePayment"])
                    this.deliveryInvoicePayment!.push(DeliveryInvoicePayment.fromJS(item));
            }
            if (Array.isArray(_data["payment"])) {
                this.payment = [] as any;
                for (let item of _data["payment"])
                    this.payment!.push(Payment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentTerm {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTermId"] = this.paymentTermId;
        data["name"] = this.name;
        data["label"] = this.label;
        if (Array.isArray(this.deliveryInvoice)) {
            data["deliveryInvoice"] = [];
            for (let item of this.deliveryInvoice)
                data["deliveryInvoice"].push(item.toJSON());
        }
        if (Array.isArray(this.deliveryInvoicePayment)) {
            data["deliveryInvoicePayment"] = [];
            for (let item of this.deliveryInvoicePayment)
                data["deliveryInvoicePayment"].push(item.toJSON());
        }
        if (Array.isArray(this.payment)) {
            data["payment"] = [];
            for (let item of this.payment)
                data["payment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaymentTerm {
    paymentTermId?: number;
    name?: string | undefined;
    label?: string | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
    deliveryInvoicePayment?: DeliveryInvoicePayment[] | undefined;
    payment?: Payment[] | undefined;
}

export class Payment implements IPayment {
    paymentId?: number;
    createdByUserId?: number;
    deletedByUserId?: number | undefined;
    creationDate?: Date;
    date?: Date;
    deletionDate?: Date | undefined;
    comment?: string | undefined;
    paymentTermNote?: string | undefined;
    paidBy?: string | undefined;
    amount?: number;
    paymentTermId?: number;
    accountingId?: number;
    customerId?: number;
    customer?: Customer | undefined;
    createdByUser?: User | undefined;
    paymentTerm?: PaymentTerm | undefined;
    accounting?: Accounting | undefined;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.createdByUserId = _data["createdByUserId"];
            this.deletedByUserId = _data["deletedByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.paymentTermNote = _data["paymentTermNote"];
            this.paidBy = _data["paidBy"];
            this.amount = _data["amount"];
            this.paymentTermId = _data["paymentTermId"];
            this.accountingId = _data["accountingId"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"] ? PaymentTerm.fromJS(_data["paymentTerm"]) : <any>undefined;
            this.accounting = _data["accounting"] ? Accounting.fromJS(_data["accounting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["createdByUserId"] = this.createdByUserId;
        data["deletedByUserId"] = this.deletedByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["paymentTermNote"] = this.paymentTermNote;
        data["paidBy"] = this.paidBy;
        data["amount"] = this.amount;
        data["paymentTermId"] = this.paymentTermId;
        data["accountingId"] = this.accountingId;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : <any>undefined;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPayment {
    paymentId?: number;
    createdByUserId?: number;
    deletedByUserId?: number | undefined;
    creationDate?: Date;
    date?: Date;
    deletionDate?: Date | undefined;
    comment?: string | undefined;
    paymentTermNote?: string | undefined;
    paidBy?: string | undefined;
    amount?: number;
    paymentTermId?: number;
    accountingId?: number;
    customerId?: number;
    customer?: Customer | undefined;
    createdByUser?: User | undefined;
    paymentTerm?: PaymentTerm | undefined;
    accounting?: Accounting | undefined;
}

export class Customer implements ICustomer {
    customerId?: number;
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    address?: string | undefined;
    companyName?: string | undefined;
    companyIdentificationNumber?: string | undefined;
    contact?: string | undefined;
    createdByUser?: User | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
    payment?: Payment[] | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isDeleted = _data["isDeleted"];
            this.address = _data["address"];
            this.companyName = _data["companyName"];
            this.companyIdentificationNumber = _data["companyIdentificationNumber"];
            this.contact = _data["contact"];
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            if (Array.isArray(_data["deliveryInvoice"])) {
                this.deliveryInvoice = [] as any;
                for (let item of _data["deliveryInvoice"])
                    this.deliveryInvoice!.push(DeliveryInvoice.fromJS(item));
            }
            if (Array.isArray(_data["payment"])) {
                this.payment = [] as any;
                for (let item of _data["payment"])
                    this.payment!.push(Payment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isDeleted"] = this.isDeleted;
        data["address"] = this.address;
        data["companyName"] = this.companyName;
        data["companyIdentificationNumber"] = this.companyIdentificationNumber;
        data["contact"] = this.contact;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.deliveryInvoice)) {
            data["deliveryInvoice"] = [];
            for (let item of this.deliveryInvoice)
                data["deliveryInvoice"].push(item.toJSON());
        }
        if (Array.isArray(this.payment)) {
            data["payment"] = [];
            for (let item of this.payment)
                data["payment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomer {
    customerId?: number;
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    address?: string | undefined;
    companyName?: string | undefined;
    companyIdentificationNumber?: string | undefined;
    contact?: string | undefined;
    createdByUser?: User | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
    payment?: Payment[] | undefined;
}

export class InvoiceStatus implements IInvoiceStatus {
    invoiceStatusId?: number;
    name?: string | undefined;
    label?: string | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;

    constructor(data?: IInvoiceStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.name = _data["name"];
            this.label = _data["label"];
            if (Array.isArray(_data["deliveryInvoice"])) {
                this.deliveryInvoice = [] as any;
                for (let item of _data["deliveryInvoice"])
                    this.deliveryInvoice!.push(DeliveryInvoice.fromJS(item));
            }
            if (Array.isArray(_data["furnisherInvoice"])) {
                this.furnisherInvoice = [] as any;
                for (let item of _data["furnisherInvoice"])
                    this.furnisherInvoice!.push(FurnisherInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["name"] = this.name;
        data["label"] = this.label;
        if (Array.isArray(this.deliveryInvoice)) {
            data["deliveryInvoice"] = [];
            for (let item of this.deliveryInvoice)
                data["deliveryInvoice"].push(item.toJSON());
        }
        if (Array.isArray(this.furnisherInvoice)) {
            data["furnisherInvoice"] = [];
            for (let item of this.furnisherInvoice)
                data["furnisherInvoice"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInvoiceStatus {
    invoiceStatusId?: number;
    name?: string | undefined;
    label?: string | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;
}

export class ApplicationUser implements IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IApplicationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data; 
    }
}

export interface IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class StockUserRole implements IStockUserRole {
    stockId?: number;
    stockUserRoleId?: number;
    userId?: string | undefined;
    stock?: Stock | undefined;
    user?: ApplicationUser | undefined;

    constructor(data?: IStockUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockId = _data["stockId"];
            this.stockUserRoleId = _data["stockUserRoleId"];
            this.userId = _data["userId"];
            this.stock = _data["stock"] ? Stock.fromJS(_data["stock"]) : <any>undefined;
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new StockUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockId"] = this.stockId;
        data["stockUserRoleId"] = this.stockUserRoleId;
        data["userId"] = this.userId;
        data["stock"] = this.stock ? this.stock.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStockUserRole {
    stockId?: number;
    stockUserRoleId?: number;
    userId?: string | undefined;
    stock?: Stock | undefined;
    user?: ApplicationUser | undefined;
}

export class Stock implements IStock {
    name?: string | undefined;
    stockId?: number;
    accountingId?: number;
    readonly products?: Product[] | undefined;
    readonly accounting?: Accounting | undefined;
    readonly stockUserRoles?: StockUserRole[] | undefined;

    constructor(data?: IStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.stockId = _data["stockId"];
            this.accountingId = _data["accountingId"];
            if (Array.isArray(_data["products"])) {
                (<any>this).products = [] as any;
                for (let item of _data["products"])
                    (<any>this).products!.push(Product.fromJS(item));
            }
            (<any>this).accounting = _data["accounting"] ? Accounting.fromJS(_data["accounting"]) : <any>undefined;
            if (Array.isArray(_data["stockUserRoles"])) {
                (<any>this).stockUserRoles = [] as any;
                for (let item of _data["stockUserRoles"])
                    (<any>this).stockUserRoles!.push(StockUserRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Stock {
        data = typeof data === 'object' ? data : {};
        let result = new Stock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stockId"] = this.stockId;
        data["accountingId"] = this.accountingId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["accounting"] = this.accounting ? this.accounting.toJSON() : <any>undefined;
        if (Array.isArray(this.stockUserRoles)) {
            data["stockUserRoles"] = [];
            for (let item of this.stockUserRoles)
                data["stockUserRoles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStock {
    name?: string | undefined;
    stockId?: number;
    accountingId?: number;
    products?: Product[] | undefined;
    accounting?: Accounting | undefined;
    stockUserRoles?: StockUserRole[] | undefined;
}

export class ProductCategory implements IProductCategory {
    productCategoryId?: number;
    name?: string | undefined;
    label?: string | undefined;
    parentId?: number | undefined;
    parent?: ProductCategory | undefined;
    inverseParent?: ProductCategory[] | undefined;
    product?: Product[] | undefined;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCategoryId = _data["productCategoryId"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? ProductCategory.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["inverseParent"])) {
                this.inverseParent = [] as any;
                for (let item of _data["inverseParent"])
                    this.inverseParent!.push(ProductCategory.fromJS(item));
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategoryId"] = this.productCategoryId;
        data["name"] = this.name;
        data["label"] = this.label;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.inverseParent)) {
            data["inverseParent"] = [];
            for (let item of this.inverseParent)
                data["inverseParent"].push(item.toJSON());
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductCategory {
    productCategoryId?: number;
    name?: string | undefined;
    label?: string | undefined;
    parentId?: number | undefined;
    parent?: ProductCategory | undefined;
    inverseParent?: ProductCategory[] | undefined;
    product?: Product[] | undefined;
}

export class DeliveryInvoiceProduct implements IDeliveryInvoiceProduct {
    deliveryInvoiceProductId?: number;
    deliveryInvoiceId?: number;
    productId?: number;
    quantity?: number;
    description?: string | undefined;
    unitPriceIncludedVat?: number;
    discount?: number;
    deliveryInvoice?: DeliveryInvoice | undefined;
    product?: Product | undefined;

    constructor(data?: IDeliveryInvoiceProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryInvoiceProductId = _data["deliveryInvoiceProductId"];
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.unitPriceIncludedVat = _data["unitPriceIncludedVat"];
            this.discount = _data["discount"];
            this.deliveryInvoice = _data["deliveryInvoice"] ? DeliveryInvoice.fromJS(_data["deliveryInvoice"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryInvoiceProduct {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryInvoiceProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryInvoiceProductId"] = this.deliveryInvoiceProductId;
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["unitPriceIncludedVat"] = this.unitPriceIncludedVat;
        data["discount"] = this.discount;
        data["deliveryInvoice"] = this.deliveryInvoice ? this.deliveryInvoice.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeliveryInvoiceProduct {
    deliveryInvoiceProductId?: number;
    deliveryInvoiceId?: number;
    productId?: number;
    quantity?: number;
    description?: string | undefined;
    unitPriceIncludedVat?: number;
    discount?: number;
    deliveryInvoice?: DeliveryInvoice | undefined;
    product?: Product | undefined;
}

export class Product implements IProduct {
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    creationDate?: Date;
    createdByUserId?: number;
    isDeleted?: boolean;
    unitPurchasePrice?: number;
    productCategoryId?: number;
    unitSalePrice?: number;
    accountingId?: number;
    uniqueCode?: string;
    stockId?: number | undefined;
    accounting?: Accounting | undefined;
    stock?: Stock | undefined;
    createdByUser?: User | undefined;
    productCategory?: ProductCategory | undefined;
    deliveryInvoiceProduct?: DeliveryInvoiceProduct[] | undefined;
    furnisherInvoiceProduct?: FurnisherInvoiceProduct[] | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.isDeleted = _data["isDeleted"];
            this.unitPurchasePrice = _data["unitPurchasePrice"];
            this.productCategoryId = _data["productCategoryId"];
            this.unitSalePrice = _data["unitSalePrice"];
            this.accountingId = _data["accountingId"];
            this.uniqueCode = _data["uniqueCode"];
            this.stockId = _data["stockId"];
            this.accounting = _data["accounting"] ? Accounting.fromJS(_data["accounting"]) : <any>undefined;
            this.stock = _data["stock"] ? Stock.fromJS(_data["stock"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            if (Array.isArray(_data["deliveryInvoiceProduct"])) {
                this.deliveryInvoiceProduct = [] as any;
                for (let item of _data["deliveryInvoiceProduct"])
                    this.deliveryInvoiceProduct!.push(DeliveryInvoiceProduct.fromJS(item));
            }
            if (Array.isArray(_data["furnisherInvoiceProduct"])) {
                this.furnisherInvoiceProduct = [] as any;
                for (let item of _data["furnisherInvoiceProduct"])
                    this.furnisherInvoiceProduct!.push(FurnisherInvoiceProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["isDeleted"] = this.isDeleted;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["productCategoryId"] = this.productCategoryId;
        data["unitSalePrice"] = this.unitSalePrice;
        data["accountingId"] = this.accountingId;
        data["uniqueCode"] = this.uniqueCode;
        data["stockId"] = this.stockId;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : <any>undefined;
        data["stock"] = this.stock ? this.stock.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.deliveryInvoiceProduct)) {
            data["deliveryInvoiceProduct"] = [];
            for (let item of this.deliveryInvoiceProduct)
                data["deliveryInvoiceProduct"].push(item.toJSON());
        }
        if (Array.isArray(this.furnisherInvoiceProduct)) {
            data["furnisherInvoiceProduct"] = [];
            for (let item of this.furnisherInvoiceProduct)
                data["furnisherInvoiceProduct"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProduct {
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    creationDate?: Date;
    createdByUserId?: number;
    isDeleted?: boolean;
    unitPurchasePrice?: number;
    productCategoryId?: number;
    unitSalePrice?: number;
    accountingId?: number;
    uniqueCode?: string;
    stockId?: number | undefined;
    accounting?: Accounting | undefined;
    stock?: Stock | undefined;
    createdByUser?: User | undefined;
    productCategory?: ProductCategory | undefined;
    deliveryInvoiceProduct?: DeliveryInvoiceProduct[] | undefined;
    furnisherInvoiceProduct?: FurnisherInvoiceProduct[] | undefined;
}

export class FurnisherInvoiceProduct implements IFurnisherInvoiceProduct {
    furnisherInvoiceProductId?: number;
    furnisherInvoiceId?: number;
    productId?: number;
    quantity?: number;
    description?: string | undefined;
    unitPrice?: number;
    discount?: number;
    furnisherInvoice?: FurnisherInvoice | undefined;
    product?: Product | undefined;

    constructor(data?: IFurnisherInvoiceProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherInvoiceProductId = _data["furnisherInvoiceProductId"];
            this.furnisherInvoiceId = _data["furnisherInvoiceId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.furnisherInvoice = _data["furnisherInvoice"] ? FurnisherInvoice.fromJS(_data["furnisherInvoice"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FurnisherInvoiceProduct {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherInvoiceProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherInvoiceProductId"] = this.furnisherInvoiceProductId;
        data["furnisherInvoiceId"] = this.furnisherInvoiceId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["furnisherInvoice"] = this.furnisherInvoice ? this.furnisherInvoice.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFurnisherInvoiceProduct {
    furnisherInvoiceProductId?: number;
    furnisherInvoiceId?: number;
    productId?: number;
    quantity?: number;
    description?: string | undefined;
    unitPrice?: number;
    discount?: number;
    furnisherInvoice?: FurnisherInvoice | undefined;
    product?: Product | undefined;
}

export class FurnisherInvoice implements IFurnisherInvoice {
    furnisherInvoiceId?: number;
    creationDate?: Date;
    createdByUserId?: number;
    furnisherId?: number;
    note?: string | undefined;
    invoiceStatusId?: number;
    stockId?: number | undefined;
    invoicePath?: string | undefined;
    date?: Date;
    accountingId?: number;
    currencyId?: number;
    accounting?: Accounting | undefined;
    createdByUser?: User | undefined;
    furnisher?: Furnisher | undefined;
    invoiceStatus?: InvoiceStatus | undefined;
    furnisherInvoiceProducts?: FurnisherInvoiceProduct[] | undefined;

    constructor(data?: IFurnisherInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherInvoiceId = _data["furnisherInvoiceId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.furnisherId = _data["furnisherId"];
            this.note = _data["note"];
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.stockId = _data["stockId"];
            this.invoicePath = _data["invoicePath"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.accountingId = _data["accountingId"];
            this.currencyId = _data["currencyId"];
            this.accounting = _data["accounting"] ? Accounting.fromJS(_data["accounting"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.furnisher = _data["furnisher"] ? Furnisher.fromJS(_data["furnisher"]) : <any>undefined;
            this.invoiceStatus = _data["invoiceStatus"] ? InvoiceStatus.fromJS(_data["invoiceStatus"]) : <any>undefined;
            if (Array.isArray(_data["furnisherInvoiceProducts"])) {
                this.furnisherInvoiceProducts = [] as any;
                for (let item of _data["furnisherInvoiceProducts"])
                    this.furnisherInvoiceProducts!.push(FurnisherInvoiceProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FurnisherInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherInvoiceId"] = this.furnisherInvoiceId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["furnisherId"] = this.furnisherId;
        data["note"] = this.note;
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["stockId"] = this.stockId;
        data["invoicePath"] = this.invoicePath;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["accountingId"] = this.accountingId;
        data["currencyId"] = this.currencyId;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["furnisher"] = this.furnisher ? this.furnisher.toJSON() : <any>undefined;
        data["invoiceStatus"] = this.invoiceStatus ? this.invoiceStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.furnisherInvoiceProducts)) {
            data["furnisherInvoiceProducts"] = [];
            for (let item of this.furnisherInvoiceProducts)
                data["furnisherInvoiceProducts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFurnisherInvoice {
    furnisherInvoiceId?: number;
    creationDate?: Date;
    createdByUserId?: number;
    furnisherId?: number;
    note?: string | undefined;
    invoiceStatusId?: number;
    stockId?: number | undefined;
    invoicePath?: string | undefined;
    date?: Date;
    accountingId?: number;
    currencyId?: number;
    accounting?: Accounting | undefined;
    createdByUser?: User | undefined;
    furnisher?: Furnisher | undefined;
    invoiceStatus?: InvoiceStatus | undefined;
    furnisherInvoiceProducts?: FurnisherInvoiceProduct[] | undefined;
}

export class Furnisher implements IFurnisher {
    furnisherId?: number;
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    address?: string | undefined;
    companyName?: string | undefined;
    companyIdentificationNumber?: string | undefined;
    contact?: string | undefined;
    createdByUser?: User | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;

    constructor(data?: IFurnisher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherId = _data["furnisherId"];
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isDeleted = _data["isDeleted"];
            this.address = _data["address"];
            this.companyName = _data["companyName"];
            this.companyIdentificationNumber = _data["companyIdentificationNumber"];
            this.contact = _data["contact"];
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            if (Array.isArray(_data["furnisherInvoice"])) {
                this.furnisherInvoice = [] as any;
                for (let item of _data["furnisherInvoice"])
                    this.furnisherInvoice!.push(FurnisherInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Furnisher {
        data = typeof data === 'object' ? data : {};
        let result = new Furnisher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherId"] = this.furnisherId;
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isDeleted"] = this.isDeleted;
        data["address"] = this.address;
        data["companyName"] = this.companyName;
        data["companyIdentificationNumber"] = this.companyIdentificationNumber;
        data["contact"] = this.contact;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.furnisherInvoice)) {
            data["furnisherInvoice"] = [];
            for (let item of this.furnisherInvoice)
                data["furnisherInvoice"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFurnisher {
    furnisherId?: number;
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    address?: string | undefined;
    companyName?: string | undefined;
    companyIdentificationNumber?: string | undefined;
    contact?: string | undefined;
    createdByUser?: User | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;
}

export class Session implements ISession {
    sessionId?: number;
    loginDateTime?: Date;
    userId?: number;
    logoutDateTime?: Date;
    authToken?: string | undefined;
    issuedOn?: Date;
    expiresOn?: Date;
    user?: User | undefined;

    constructor(data?: ISession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.loginDateTime = _data["loginDateTime"] ? new Date(_data["loginDateTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.logoutDateTime = _data["logoutDateTime"] ? new Date(_data["logoutDateTime"].toString()) : <any>undefined;
            this.authToken = _data["authToken"];
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>undefined;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Session {
        data = typeof data === 'object' ? data : {};
        let result = new Session();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["loginDateTime"] = this.loginDateTime ? this.loginDateTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["logoutDateTime"] = this.logoutDateTime ? this.logoutDateTime.toISOString() : <any>undefined;
        data["authToken"] = this.authToken;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>undefined;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISession {
    sessionId?: number;
    loginDateTime?: Date;
    userId?: number;
    logoutDateTime?: Date;
    authToken?: string | undefined;
    issuedOn?: Date;
    expiresOn?: Date;
    user?: User | undefined;
}

export class ExpenseKind implements IExpenseKind {
    expenseKindId?: number;
    name?: string | undefined;
    createdByUserId?: number;
    creationDate?: Date;
    createdByUser?: User | undefined;
    expenses?: Expense[] | undefined;

    constructor(data?: IExpenseKind) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseKindId = _data["expenseKindId"];
            this.name = _data["name"];
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(Expense.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpenseKind {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseKind();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseKindId"] = this.expenseKindId;
        data["name"] = this.name;
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExpenseKind {
    expenseKindId?: number;
    name?: string | undefined;
    createdByUserId?: number;
    creationDate?: Date;
    createdByUser?: User | undefined;
    expenses?: Expense[] | undefined;
}

export class Expense implements IExpense {
    amount?: number;
    comment?: string | undefined;
    createdByUserId?: number;
    creationDate?: Date;
    date?: Date;
    deletedByUserId?: number;
    deletionDate?: Date | undefined;
    expenseId?: number;
    expenseKindId?: number;
    createdByUser?: User | undefined;
    expenseKind?: ExpenseKind | undefined;

    constructor(data?: IExpense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.comment = _data["comment"];
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : <any>undefined;
            this.expenseId = _data["expenseId"];
            this.expenseKindId = _data["expenseKindId"];
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.expenseKind = _data["expenseKind"] ? ExpenseKind.fromJS(_data["expenseKind"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Expense {
        data = typeof data === 'object' ? data : {};
        let result = new Expense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["comment"] = this.comment;
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : <any>undefined;
        data["expenseId"] = this.expenseId;
        data["expenseKindId"] = this.expenseKindId;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["expenseKind"] = this.expenseKind ? this.expenseKind.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExpense {
    amount?: number;
    comment?: string | undefined;
    createdByUserId?: number;
    creationDate?: Date;
    date?: Date;
    deletedByUserId?: number;
    deletionDate?: Date | undefined;
    expenseId?: number;
    expenseKindId?: number;
    createdByUser?: User | undefined;
    expenseKind?: ExpenseKind | undefined;
}

export class User implements IUser {
    userId?: number;
    aspNetUserId?: string | undefined;
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
    password?: string | undefined;
    username?: string | undefined;
    isCommercial?: boolean;
    createdByUser?: User | undefined;
    customer?: Customer[] | undefined;
    payment?: Payment[] | undefined;
    deliveryInvoiceCommercial?: DeliveryInvoice[] | undefined;
    deliveryInvoiceCreatedByUser?: DeliveryInvoice[] | undefined;
    furnisher?: Furnisher[] | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;
    inverseCreatedByUser?: User[] | undefined;
    product?: Product[] | undefined;
    session?: Session[] | undefined;
    expenses?: Expense[] | undefined;
    expenseKinds?: ExpenseKind[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.aspNetUserId = _data["aspNetUserId"];
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
            this.password = _data["password"];
            this.username = _data["username"];
            this.isCommercial = _data["isCommercial"];
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            if (Array.isArray(_data["customer"])) {
                this.customer = [] as any;
                for (let item of _data["customer"])
                    this.customer!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["payment"])) {
                this.payment = [] as any;
                for (let item of _data["payment"])
                    this.payment!.push(Payment.fromJS(item));
            }
            if (Array.isArray(_data["deliveryInvoiceCommercial"])) {
                this.deliveryInvoiceCommercial = [] as any;
                for (let item of _data["deliveryInvoiceCommercial"])
                    this.deliveryInvoiceCommercial!.push(DeliveryInvoice.fromJS(item));
            }
            if (Array.isArray(_data["deliveryInvoiceCreatedByUser"])) {
                this.deliveryInvoiceCreatedByUser = [] as any;
                for (let item of _data["deliveryInvoiceCreatedByUser"])
                    this.deliveryInvoiceCreatedByUser!.push(DeliveryInvoice.fromJS(item));
            }
            if (Array.isArray(_data["furnisher"])) {
                this.furnisher = [] as any;
                for (let item of _data["furnisher"])
                    this.furnisher!.push(Furnisher.fromJS(item));
            }
            if (Array.isArray(_data["furnisherInvoice"])) {
                this.furnisherInvoice = [] as any;
                for (let item of _data["furnisherInvoice"])
                    this.furnisherInvoice!.push(FurnisherInvoice.fromJS(item));
            }
            if (Array.isArray(_data["inverseCreatedByUser"])) {
                this.inverseCreatedByUser = [] as any;
                for (let item of _data["inverseCreatedByUser"])
                    this.inverseCreatedByUser!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["session"])) {
                this.session = [] as any;
                for (let item of _data["session"])
                    this.session!.push(Session.fromJS(item));
            }
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(Expense.fromJS(item));
            }
            if (Array.isArray(_data["expenseKinds"])) {
                this.expenseKinds = [] as any;
                for (let item of _data["expenseKinds"])
                    this.expenseKinds!.push(ExpenseKind.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["aspNetUserId"] = this.aspNetUserId;
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        data["password"] = this.password;
        data["username"] = this.username;
        data["isCommercial"] = this.isCommercial;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.customer)) {
            data["customer"] = [];
            for (let item of this.customer)
                data["customer"].push(item.toJSON());
        }
        if (Array.isArray(this.payment)) {
            data["payment"] = [];
            for (let item of this.payment)
                data["payment"].push(item.toJSON());
        }
        if (Array.isArray(this.deliveryInvoiceCommercial)) {
            data["deliveryInvoiceCommercial"] = [];
            for (let item of this.deliveryInvoiceCommercial)
                data["deliveryInvoiceCommercial"].push(item.toJSON());
        }
        if (Array.isArray(this.deliveryInvoiceCreatedByUser)) {
            data["deliveryInvoiceCreatedByUser"] = [];
            for (let item of this.deliveryInvoiceCreatedByUser)
                data["deliveryInvoiceCreatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.furnisher)) {
            data["furnisher"] = [];
            for (let item of this.furnisher)
                data["furnisher"].push(item.toJSON());
        }
        if (Array.isArray(this.furnisherInvoice)) {
            data["furnisherInvoice"] = [];
            for (let item of this.furnisherInvoice)
                data["furnisherInvoice"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseCreatedByUser)) {
            data["inverseCreatedByUser"] = [];
            for (let item of this.inverseCreatedByUser)
                data["inverseCreatedByUser"].push(item.toJSON());
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item.toJSON());
        }
        if (Array.isArray(this.session)) {
            data["session"] = [];
            for (let item of this.session)
                data["session"].push(item.toJSON());
        }
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item.toJSON());
        }
        if (Array.isArray(this.expenseKinds)) {
            data["expenseKinds"] = [];
            for (let item of this.expenseKinds)
                data["expenseKinds"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUser {
    userId?: number;
    aspNetUserId?: string | undefined;
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
    password?: string | undefined;
    username?: string | undefined;
    isCommercial?: boolean;
    createdByUser?: User | undefined;
    customer?: Customer[] | undefined;
    payment?: Payment[] | undefined;
    deliveryInvoiceCommercial?: DeliveryInvoice[] | undefined;
    deliveryInvoiceCreatedByUser?: DeliveryInvoice[] | undefined;
    furnisher?: Furnisher[] | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;
    inverseCreatedByUser?: User[] | undefined;
    product?: Product[] | undefined;
    session?: Session[] | undefined;
    expenses?: Expense[] | undefined;
    expenseKinds?: ExpenseKind[] | undefined;
}

export class InvoicePaymentStatus implements IInvoicePaymentStatus {
    invoicePaymentStatusId?: number;
    name?: string | undefined;
    label?: string | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;

    constructor(data?: IInvoicePaymentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoicePaymentStatusId = _data["invoicePaymentStatusId"];
            this.name = _data["name"];
            this.label = _data["label"];
            if (Array.isArray(_data["deliveryInvoice"])) {
                this.deliveryInvoice = [] as any;
                for (let item of _data["deliveryInvoice"])
                    this.deliveryInvoice!.push(DeliveryInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicePaymentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaymentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicePaymentStatusId"] = this.invoicePaymentStatusId;
        data["name"] = this.name;
        data["label"] = this.label;
        if (Array.isArray(this.deliveryInvoice)) {
            data["deliveryInvoice"] = [];
            for (let item of this.deliveryInvoice)
                data["deliveryInvoice"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInvoicePaymentStatus {
    invoicePaymentStatusId?: number;
    name?: string | undefined;
    label?: string | undefined;
    deliveryInvoice?: DeliveryInvoice[] | undefined;
}

export class DeliveryInvoice implements IDeliveryInvoice {
    deliveryInvoiceId?: number;
    invoiceIdentifier?: string;
    creationDate?: Date;
    createdByUserId?: number;
    customerId?: number;
    note?: string | undefined;
    invoiceStatusId?: number;
    invoicePath?: string | undefined;
    date?: Date;
    vat?: number;
    customDeliveryInvoiceNumber?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    invoicePaymentStatusId?: number;
    accountingId?: number;
    commercialId?: number;
    commercial?: User | undefined;
    createdByUser?: User | undefined;
    customer?: Customer | undefined;
    invoicePaymentStatus?: InvoicePaymentStatus | undefined;
    invoiceStatus?: InvoiceStatus | undefined;
    accounting?: Accounting | undefined;
    paymentTerm?: PaymentTerm | undefined;
    deliveryInvoicePayments?: DeliveryInvoicePayment[] | undefined;
    deliveryInvoiceProducts?: DeliveryInvoiceProduct[] | undefined;

    constructor(data?: IDeliveryInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            this.invoiceIdentifier = _data["invoiceIdentifier"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.customerId = _data["customerId"];
            this.note = _data["note"];
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.invoicePath = _data["invoicePath"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.vat = _data["vat"];
            this.customDeliveryInvoiceNumber = _data["customDeliveryInvoiceNumber"];
            this.paymentTermId = _data["paymentTermId"];
            this.paymentTermNote = _data["paymentTermNote"];
            this.taxOnCash = _data["taxOnCash"];
            this.invoicePaymentStatusId = _data["invoicePaymentStatusId"];
            this.accountingId = _data["accountingId"];
            this.commercialId = _data["commercialId"];
            this.commercial = _data["commercial"] ? User.fromJS(_data["commercial"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.invoicePaymentStatus = _data["invoicePaymentStatus"] ? InvoicePaymentStatus.fromJS(_data["invoicePaymentStatus"]) : <any>undefined;
            this.invoiceStatus = _data["invoiceStatus"] ? InvoiceStatus.fromJS(_data["invoiceStatus"]) : <any>undefined;
            this.accounting = _data["accounting"] ? Accounting.fromJS(_data["accounting"]) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"] ? PaymentTerm.fromJS(_data["paymentTerm"]) : <any>undefined;
            if (Array.isArray(_data["deliveryInvoicePayments"])) {
                this.deliveryInvoicePayments = [] as any;
                for (let item of _data["deliveryInvoicePayments"])
                    this.deliveryInvoicePayments!.push(DeliveryInvoicePayment.fromJS(item));
            }
            if (Array.isArray(_data["deliveryInvoiceProducts"])) {
                this.deliveryInvoiceProducts = [] as any;
                for (let item of _data["deliveryInvoiceProducts"])
                    this.deliveryInvoiceProducts!.push(DeliveryInvoiceProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        data["invoiceIdentifier"] = this.invoiceIdentifier;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["customerId"] = this.customerId;
        data["note"] = this.note;
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["invoicePath"] = this.invoicePath;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["vat"] = this.vat;
        data["customDeliveryInvoiceNumber"] = this.customDeliveryInvoiceNumber;
        data["paymentTermId"] = this.paymentTermId;
        data["paymentTermNote"] = this.paymentTermNote;
        data["taxOnCash"] = this.taxOnCash;
        data["invoicePaymentStatusId"] = this.invoicePaymentStatusId;
        data["accountingId"] = this.accountingId;
        data["commercialId"] = this.commercialId;
        data["commercial"] = this.commercial ? this.commercial.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["invoicePaymentStatus"] = this.invoicePaymentStatus ? this.invoicePaymentStatus.toJSON() : <any>undefined;
        data["invoiceStatus"] = this.invoiceStatus ? this.invoiceStatus.toJSON() : <any>undefined;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : <any>undefined;
        if (Array.isArray(this.deliveryInvoicePayments)) {
            data["deliveryInvoicePayments"] = [];
            for (let item of this.deliveryInvoicePayments)
                data["deliveryInvoicePayments"].push(item.toJSON());
        }
        if (Array.isArray(this.deliveryInvoiceProducts)) {
            data["deliveryInvoiceProducts"] = [];
            for (let item of this.deliveryInvoiceProducts)
                data["deliveryInvoiceProducts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeliveryInvoice {
    deliveryInvoiceId?: number;
    invoiceIdentifier?: string;
    creationDate?: Date;
    createdByUserId?: number;
    customerId?: number;
    note?: string | undefined;
    invoiceStatusId?: number;
    invoicePath?: string | undefined;
    date?: Date;
    vat?: number;
    customDeliveryInvoiceNumber?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    invoicePaymentStatusId?: number;
    accountingId?: number;
    commercialId?: number;
    commercial?: User | undefined;
    createdByUser?: User | undefined;
    customer?: Customer | undefined;
    invoicePaymentStatus?: InvoicePaymentStatus | undefined;
    invoiceStatus?: InvoiceStatus | undefined;
    accounting?: Accounting | undefined;
    paymentTerm?: PaymentTerm | undefined;
    deliveryInvoicePayments?: DeliveryInvoicePayment[] | undefined;
    deliveryInvoiceProducts?: DeliveryInvoiceProduct[] | undefined;
}

export class AccountingUserRole implements IAccountingUserRole {
    accountingId?: number;
    accountingUserRoleId?: number;
    accounting?: Accounting | undefined;
    user?: ApplicationUser | undefined;
    userId?: string | undefined;

    constructor(data?: IAccountingUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.accountingUserRoleId = _data["accountingUserRoleId"];
            this.accounting = _data["accounting"] ? Accounting.fromJS(_data["accounting"]) : <any>undefined;
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AccountingUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["accountingUserRoleId"] = this.accountingUserRoleId;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IAccountingUserRole {
    accountingId?: number;
    accountingUserRoleId?: number;
    accounting?: Accounting | undefined;
    user?: ApplicationUser | undefined;
    userId?: string | undefined;
}

export class Accounting implements IAccounting {
    accountingId?: number;
    name?: string | undefined;
    description?: string | undefined;
    useVat?: boolean;
    accountingDetail?: AccountingDetail | undefined;
    readonly deliveryInvoices?: DeliveryInvoice[] | undefined;
    readonly payment?: Payment[] | undefined;
    readonly stocks?: Stock[] | undefined;
    readonly furnisherInvoice?: FurnisherInvoice[] | undefined;
    products?: Product[] | undefined;
    readonly accountingUserRoles?: AccountingUserRole[] | undefined;

    constructor(data?: IAccounting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.useVat = _data["useVat"];
            this.accountingDetail = _data["accountingDetail"] ? AccountingDetail.fromJS(_data["accountingDetail"]) : <any>undefined;
            if (Array.isArray(_data["deliveryInvoices"])) {
                (<any>this).deliveryInvoices = [] as any;
                for (let item of _data["deliveryInvoices"])
                    (<any>this).deliveryInvoices!.push(DeliveryInvoice.fromJS(item));
            }
            if (Array.isArray(_data["payment"])) {
                (<any>this).payment = [] as any;
                for (let item of _data["payment"])
                    (<any>this).payment!.push(Payment.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                (<any>this).stocks = [] as any;
                for (let item of _data["stocks"])
                    (<any>this).stocks!.push(Stock.fromJS(item));
            }
            if (Array.isArray(_data["furnisherInvoice"])) {
                (<any>this).furnisherInvoice = [] as any;
                for (let item of _data["furnisherInvoice"])
                    (<any>this).furnisherInvoice!.push(FurnisherInvoice.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["accountingUserRoles"])) {
                (<any>this).accountingUserRoles = [] as any;
                for (let item of _data["accountingUserRoles"])
                    (<any>this).accountingUserRoles!.push(AccountingUserRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Accounting {
        data = typeof data === 'object' ? data : {};
        let result = new Accounting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["useVat"] = this.useVat;
        data["accountingDetail"] = this.accountingDetail ? this.accountingDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.deliveryInvoices)) {
            data["deliveryInvoices"] = [];
            for (let item of this.deliveryInvoices)
                data["deliveryInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.payment)) {
            data["payment"] = [];
            for (let item of this.payment)
                data["payment"].push(item.toJSON());
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        if (Array.isArray(this.furnisherInvoice)) {
            data["furnisherInvoice"] = [];
            for (let item of this.furnisherInvoice)
                data["furnisherInvoice"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.accountingUserRoles)) {
            data["accountingUserRoles"] = [];
            for (let item of this.accountingUserRoles)
                data["accountingUserRoles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAccounting {
    accountingId?: number;
    name?: string | undefined;
    description?: string | undefined;
    useVat?: boolean;
    accountingDetail?: AccountingDetail | undefined;
    deliveryInvoices?: DeliveryInvoice[] | undefined;
    payment?: Payment[] | undefined;
    stocks?: Stock[] | undefined;
    furnisherInvoice?: FurnisherInvoice[] | undefined;
    products?: Product[] | undefined;
    accountingUserRoles?: AccountingUserRole[] | undefined;
}

export class AccountingDetailDto implements IAccountingDetailDto {
    accountingDetailId?: number;
    accountingId?: number;
    endPeriod?: Date;
    percentageCashTax?: number;
    percentageVat?: number;
    startPeriod?: Date;
    useVat?: boolean;

    constructor(data?: IAccountingDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingDetailId = _data["accountingDetailId"];
            this.accountingId = _data["accountingId"];
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
            this.percentageCashTax = _data["percentageCashTax"];
            this.percentageVat = _data["percentageVat"];
            this.startPeriod = _data["startPeriod"] ? new Date(_data["startPeriod"].toString()) : <any>undefined;
            this.useVat = _data["useVat"];
        }
    }

    static fromJS(data: any): AccountingDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingDetailId"] = this.accountingDetailId;
        data["accountingId"] = this.accountingId;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["percentageCashTax"] = this.percentageCashTax;
        data["percentageVat"] = this.percentageVat;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["useVat"] = this.useVat;
        return data; 
    }
}

export interface IAccountingDetailDto {
    accountingDetailId?: number;
    accountingId?: number;
    endPeriod?: Date;
    percentageCashTax?: number;
    percentageVat?: number;
    startPeriod?: Date;
    useVat?: boolean;
}

export class DashboardDto implements IDashboardDto {
    totalSignedInvoicesAmount?: number;
    totalQuotationInvoicesAmount?: number;
    totalPayments?: number;
    totalExpenses?: number;
    startPeriod?: Date;
    endPeriod?: Date;

    constructor(data?: IDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSignedInvoicesAmount = _data["totalSignedInvoicesAmount"];
            this.totalQuotationInvoicesAmount = _data["totalQuotationInvoicesAmount"];
            this.totalPayments = _data["totalPayments"];
            this.totalExpenses = _data["totalExpenses"];
            this.startPeriod = _data["startPeriod"] ? new Date(_data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSignedInvoicesAmount"] = this.totalSignedInvoicesAmount;
        data["totalQuotationInvoicesAmount"] = this.totalQuotationInvoicesAmount;
        data["totalPayments"] = this.totalPayments;
        data["totalExpenses"] = this.totalExpenses;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDashboardDto {
    totalSignedInvoicesAmount?: number;
    totalQuotationInvoicesAmount?: number;
    totalPayments?: number;
    totalExpenses?: number;
    startPeriod?: Date;
    endPeriod?: Date;
}

export class UserDto implements IUserDto {
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    isActive?: boolean;
    lastName?: string | undefined;
    userId?: number;
    username?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.isActive = _data["isActive"];
            this.lastName = _data["lastName"];
            this.userId = _data["userId"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["isActive"] = this.isActive;
        data["lastName"] = this.lastName;
        data["userId"] = this.userId;
        data["username"] = this.username;
        return data; 
    }
}

export interface IUserDto {
    createdByUserId?: number;
    creationDate?: Date;
    firstName?: string | undefined;
    isActive?: boolean;
    lastName?: string | undefined;
    userId?: number;
    username?: string | undefined;
}

export class LoginDto implements ILoginDto {
    password?: string | undefined;
    username?: string | undefined;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["username"] = this.username;
        return data; 
    }
}

export interface ILoginDto {
    password?: string | undefined;
    username?: string | undefined;
}

export class Currency implements ICurrency {
    currencyId?: number;
    code?: string | undefined;
    label?: string | undefined;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyId = _data["currencyId"];
            this.code = _data["code"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["code"] = this.code;
        data["label"] = this.label;
        return data; 
    }
}

export interface ICurrency {
    currencyId?: number;
    code?: string | undefined;
    label?: string | undefined;
}

export class CustomerRevenue implements ICustomerRevenue {
    customerId?: number;
    sumSignedInvoicesAmount?: number;
    sumQuotationInvoicesAmount?: number;
    totalAmountPayment?: number;
    startPeriod?: Date;
    endPeriod?: Date;

    constructor(data?: ICustomerRevenue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.sumSignedInvoicesAmount = _data["sumSignedInvoicesAmount"];
            this.sumQuotationInvoicesAmount = _data["sumQuotationInvoicesAmount"];
            this.totalAmountPayment = _data["totalAmountPayment"];
            this.startPeriod = _data["startPeriod"] ? new Date(_data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerRevenue {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRevenue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["sumSignedInvoicesAmount"] = this.sumSignedInvoicesAmount;
        data["sumQuotationInvoicesAmount"] = this.sumQuotationInvoicesAmount;
        data["totalAmountPayment"] = this.totalAmountPayment;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICustomerRevenue {
    customerId?: number;
    sumSignedInvoicesAmount?: number;
    sumQuotationInvoicesAmount?: number;
    totalAmountPayment?: number;
    startPeriod?: Date;
    endPeriod?: Date;
}

export enum SortOrderType {
    _0 = 0,
    _1 = 1,
}

export class FilterDto implements IFilterDto {
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;

    constructor(data?: IFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.stockId = _data["stockId"];
        }
    }

    static fromJS(data: any): FilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["stockId"] = this.stockId;
        return data; 
    }
}

export interface IFilterDto {
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;
}

export class CustomerPaginatedDto implements ICustomerPaginatedDto {
    data?: Customer[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: ICustomerPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Customer.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): CustomerPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface ICustomerPaginatedDto {
    data?: Customer[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class DeliveryInvoiceFilter implements IDeliveryInvoiceFilter {
    customerId?: number | undefined;
    onlyToSign?: boolean;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;

    constructor(data?: IDeliveryInvoiceFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.onlyToSign = _data["onlyToSign"];
            this.accountingId = _data["accountingId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.stockId = _data["stockId"];
        }
    }

    static fromJS(data: any): DeliveryInvoiceFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryInvoiceFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["onlyToSign"] = this.onlyToSign;
        data["accountingId"] = this.accountingId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["stockId"] = this.stockId;
        return data; 
    }
}

export interface IDeliveryInvoiceFilter {
    customerId?: number | undefined;
    onlyToSign?: boolean;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;
}

export class SmallDeliveryInvoiceProductDto implements ISmallDeliveryInvoiceProductDto {
    productId?: number;
    productName?: string | undefined;
    quantity?: number;
    readonly totalPriceIncludedVat?: number;
    unitPriceIncludedVat?: number;

    constructor(data?: ISmallDeliveryInvoiceProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            (<any>this).totalPriceIncludedVat = _data["totalPriceIncludedVat"];
            this.unitPriceIncludedVat = _data["unitPriceIncludedVat"];
        }
    }

    static fromJS(data: any): SmallDeliveryInvoiceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmallDeliveryInvoiceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["totalPriceIncludedVat"] = this.totalPriceIncludedVat;
        data["unitPriceIncludedVat"] = this.unitPriceIncludedVat;
        return data; 
    }
}

export interface ISmallDeliveryInvoiceProductDto {
    productId?: number;
    productName?: string | undefined;
    quantity?: number;
    totalPriceIncludedVat?: number;
    unitPriceIncludedVat?: number;
}

export class SmallDeliveryInvoiceDto implements ISmallDeliveryInvoiceDto {
    accountingId?: number;
    customerId?: number;
    companyName?: string | undefined;
    invoiceIdentifier?: string;
    creationDate?: Date;
    customDeliveryInvoiceNumber?: string | undefined;
    date?: Date;
    deliveryInvoiceId?: number;
    deliveryInvoiceProducts?: SmallDeliveryInvoiceProductDto[] | undefined;
    invoicePaymentStatus?: string | undefined;
    invoiceStatus?: string | undefined;
    invoiceStatusId?: number;
    note?: string | undefined;
    paymentTerm?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    readonly totalNetToPay?: number;
    readonly totalPriceExcludedVat?: number;
    readonly totalPriceIncludedVat?: number;
    vat?: number;

    constructor(data?: ISmallDeliveryInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.customerId = _data["customerId"];
            this.companyName = _data["companyName"];
            this.invoiceIdentifier = _data["invoiceIdentifier"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.customDeliveryInvoiceNumber = _data["customDeliveryInvoiceNumber"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            if (Array.isArray(_data["deliveryInvoiceProducts"])) {
                this.deliveryInvoiceProducts = [] as any;
                for (let item of _data["deliveryInvoiceProducts"])
                    this.deliveryInvoiceProducts!.push(SmallDeliveryInvoiceProductDto.fromJS(item));
            }
            this.invoicePaymentStatus = _data["invoicePaymentStatus"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.note = _data["note"];
            this.paymentTerm = _data["paymentTerm"];
            this.paymentTermId = _data["paymentTermId"];
            this.paymentTermNote = _data["paymentTermNote"];
            this.taxOnCash = _data["taxOnCash"];
            (<any>this).totalNetToPay = _data["totalNetToPay"];
            (<any>this).totalPriceExcludedVat = _data["totalPriceExcludedVat"];
            (<any>this).totalPriceIncludedVat = _data["totalPriceIncludedVat"];
            this.vat = _data["vat"];
        }
    }

    static fromJS(data: any): SmallDeliveryInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmallDeliveryInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["customerId"] = this.customerId;
        data["companyName"] = this.companyName;
        data["invoiceIdentifier"] = this.invoiceIdentifier;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["customDeliveryInvoiceNumber"] = this.customDeliveryInvoiceNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        if (Array.isArray(this.deliveryInvoiceProducts)) {
            data["deliveryInvoiceProducts"] = [];
            for (let item of this.deliveryInvoiceProducts)
                data["deliveryInvoiceProducts"].push(item.toJSON());
        }
        data["invoicePaymentStatus"] = this.invoicePaymentStatus;
        data["invoiceStatus"] = this.invoiceStatus;
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["note"] = this.note;
        data["paymentTerm"] = this.paymentTerm;
        data["paymentTermId"] = this.paymentTermId;
        data["paymentTermNote"] = this.paymentTermNote;
        data["taxOnCash"] = this.taxOnCash;
        data["totalNetToPay"] = this.totalNetToPay;
        data["totalPriceExcludedVat"] = this.totalPriceExcludedVat;
        data["totalPriceIncludedVat"] = this.totalPriceIncludedVat;
        data["vat"] = this.vat;
        return data; 
    }
}

export interface ISmallDeliveryInvoiceDto {
    accountingId?: number;
    customerId?: number;
    companyName?: string | undefined;
    invoiceIdentifier?: string;
    creationDate?: Date;
    customDeliveryInvoiceNumber?: string | undefined;
    date?: Date;
    deliveryInvoiceId?: number;
    deliveryInvoiceProducts?: SmallDeliveryInvoiceProductDto[] | undefined;
    invoicePaymentStatus?: string | undefined;
    invoiceStatus?: string | undefined;
    invoiceStatusId?: number;
    note?: string | undefined;
    paymentTerm?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    totalNetToPay?: number;
    totalPriceExcludedVat?: number;
    totalPriceIncludedVat?: number;
    vat?: number;
}

export class SmallDeliveryInvoiceDtoPaginatedDto implements ISmallDeliveryInvoiceDtoPaginatedDto {
    data?: SmallDeliveryInvoiceDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: ISmallDeliveryInvoiceDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SmallDeliveryInvoiceDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): SmallDeliveryInvoiceDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmallDeliveryInvoiceDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface ISmallDeliveryInvoiceDtoPaginatedDto {
    data?: SmallDeliveryInvoiceDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class KeyParameter implements IKeyParameter {
    key?: string | undefined;
    parameter?: string | undefined;

    constructor(data?: IKeyParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.parameter = _data["parameter"];
        }
    }

    static fromJS(data: any): KeyParameter {
        data = typeof data === 'object' ? data : {};
        let result = new KeyParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["parameter"] = this.parameter;
        return data; 
    }
}

export interface IKeyParameter {
    key?: string | undefined;
    parameter?: string | undefined;
}

export class DeliveryInvoiceDto implements IDeliveryInvoiceDto {
    accountingId?: number;
    commercialFirstName?: string | undefined;
    commercialLastName?: string | undefined;
    companyAddress?: string | undefined;
    readonly companyContact?: string | undefined;
    companyName?: string | undefined;
    creationDate?: Date;
    customerId?: number;
    customDeliveryInvoiceNumber?: string | undefined;
    date?: Date;
    deliveryInvoiceId?: number;
    deliveryInvoiceProducts?: SmallDeliveryInvoiceProductDto[] | undefined;
    invoiceIdentifier?: string;
    invoicePaymentStatus?: string | undefined;
    invoiceStatus?: string | undefined;
    invoiceStatusId?: number;
    note?: string | undefined;
    paymentTerm?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    companyIdentificationNumber?: string | undefined;
    readonly totalNetToPay?: number;
    readonly totalPriceExcludedVat?: number;
    readonly totalPriceIncludedVat?: number;
    useVat?: boolean;
    vat?: number;

    constructor(data?: IDeliveryInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.commercialFirstName = _data["commercialFirstName"];
            this.commercialLastName = _data["commercialLastName"];
            this.companyAddress = _data["companyAddress"];
            (<any>this).companyContact = _data["companyContact"];
            this.companyName = _data["companyName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customDeliveryInvoiceNumber = _data["customDeliveryInvoiceNumber"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            if (Array.isArray(_data["deliveryInvoiceProducts"])) {
                this.deliveryInvoiceProducts = [] as any;
                for (let item of _data["deliveryInvoiceProducts"])
                    this.deliveryInvoiceProducts!.push(SmallDeliveryInvoiceProductDto.fromJS(item));
            }
            this.invoiceIdentifier = _data["invoiceIdentifier"];
            this.invoicePaymentStatus = _data["invoicePaymentStatus"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.note = _data["note"];
            this.paymentTerm = _data["paymentTerm"];
            this.paymentTermId = _data["paymentTermId"];
            this.paymentTermNote = _data["paymentTermNote"];
            this.taxOnCash = _data["taxOnCash"];
            this.companyIdentificationNumber = _data["companyIdentificationNumber"];
            (<any>this).totalNetToPay = _data["totalNetToPay"];
            (<any>this).totalPriceExcludedVat = _data["totalPriceExcludedVat"];
            (<any>this).totalPriceIncludedVat = _data["totalPriceIncludedVat"];
            this.useVat = _data["useVat"];
            this.vat = _data["vat"];
        }
    }

    static fromJS(data: any): DeliveryInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["commercialFirstName"] = this.commercialFirstName;
        data["commercialLastName"] = this.commercialLastName;
        data["companyAddress"] = this.companyAddress;
        data["companyContact"] = this.companyContact;
        data["companyName"] = this.companyName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customDeliveryInvoiceNumber"] = this.customDeliveryInvoiceNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        if (Array.isArray(this.deliveryInvoiceProducts)) {
            data["deliveryInvoiceProducts"] = [];
            for (let item of this.deliveryInvoiceProducts)
                data["deliveryInvoiceProducts"].push(item.toJSON());
        }
        data["invoiceIdentifier"] = this.invoiceIdentifier;
        data["invoicePaymentStatus"] = this.invoicePaymentStatus;
        data["invoiceStatus"] = this.invoiceStatus;
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["note"] = this.note;
        data["paymentTerm"] = this.paymentTerm;
        data["paymentTermId"] = this.paymentTermId;
        data["paymentTermNote"] = this.paymentTermNote;
        data["taxOnCash"] = this.taxOnCash;
        data["companyIdentificationNumber"] = this.companyIdentificationNumber;
        data["totalNetToPay"] = this.totalNetToPay;
        data["totalPriceExcludedVat"] = this.totalPriceExcludedVat;
        data["totalPriceIncludedVat"] = this.totalPriceIncludedVat;
        data["useVat"] = this.useVat;
        data["vat"] = this.vat;
        return data; 
    }
}

export interface IDeliveryInvoiceDto {
    accountingId?: number;
    commercialFirstName?: string | undefined;
    commercialLastName?: string | undefined;
    companyAddress?: string | undefined;
    companyContact?: string | undefined;
    companyName?: string | undefined;
    creationDate?: Date;
    customerId?: number;
    customDeliveryInvoiceNumber?: string | undefined;
    date?: Date;
    deliveryInvoiceId?: number;
    deliveryInvoiceProducts?: SmallDeliveryInvoiceProductDto[] | undefined;
    invoiceIdentifier?: string;
    invoicePaymentStatus?: string | undefined;
    invoiceStatus?: string | undefined;
    invoiceStatusId?: number;
    note?: string | undefined;
    paymentTerm?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    companyIdentificationNumber?: string | undefined;
    totalNetToPay?: number;
    totalPriceExcludedVat?: number;
    totalPriceIncludedVat?: number;
    useVat?: boolean;
    vat?: number;
}

export class StockDto implements IStockDto {
    name?: string | undefined;
    stockId?: number;
    accountingId?: number;

    constructor(data?: IStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.stockId = _data["stockId"];
            this.accountingId = _data["accountingId"];
        }
    }

    static fromJS(data: any): StockDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stockId"] = this.stockId;
        data["accountingId"] = this.accountingId;
        return data; 
    }
}

export interface IStockDto {
    name?: string | undefined;
    stockId?: number;
    accountingId?: number;
}

export class SmallProductDto implements ISmallProductDto {
    accountingId?: number;
    name?: string | undefined;
    productId?: number;
    quantity?: number;
    stock?: StockDto | undefined;
    stockId?: number | undefined;
    uniqueCode?: string;
    unitPurchasePrice?: number;

    constructor(data?: ISmallProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.stock = _data["stock"] ? StockDto.fromJS(_data["stock"]) : <any>undefined;
            this.stockId = _data["stockId"];
            this.uniqueCode = _data["uniqueCode"];
            this.unitPurchasePrice = _data["unitPurchasePrice"];
        }
    }

    static fromJS(data: any): SmallProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmallProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["stock"] = this.stock ? this.stock.toJSON() : <any>undefined;
        data["stockId"] = this.stockId;
        data["uniqueCode"] = this.uniqueCode;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        return data; 
    }
}

export interface ISmallProductDto {
    accountingId?: number;
    name?: string | undefined;
    productId?: number;
    quantity?: number;
    stock?: StockDto | undefined;
    stockId?: number | undefined;
    uniqueCode?: string;
    unitPurchasePrice?: number;
}

export class CrudDeliveryInvoiceProductDto implements ICrudDeliveryInvoiceProductDto {
    deliveryInvoiceProductId?: number;
    deliveryInvoiceId?: number;
    productId?: number;
    quantity?: number;
    unitPriceIncludedVat?: number;
    discount?: number;
    product?: SmallProductDto | undefined;

    constructor(data?: ICrudDeliveryInvoiceProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryInvoiceProductId = _data["deliveryInvoiceProductId"];
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.unitPriceIncludedVat = _data["unitPriceIncludedVat"];
            this.discount = _data["discount"];
            this.product = _data["product"] ? SmallProductDto.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CrudDeliveryInvoiceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrudDeliveryInvoiceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryInvoiceProductId"] = this.deliveryInvoiceProductId;
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["unitPriceIncludedVat"] = this.unitPriceIncludedVat;
        data["discount"] = this.discount;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICrudDeliveryInvoiceProductDto {
    deliveryInvoiceProductId?: number;
    deliveryInvoiceId?: number;
    productId?: number;
    quantity?: number;
    unitPriceIncludedVat?: number;
    discount?: number;
    product?: SmallProductDto | undefined;
}

export class CrudDeliveryInvoiceDto implements ICrudDeliveryInvoiceDto {
    accountingId?: number;
    commercialId?: number;
    createdByUserId?: number;
    creationDate?: Date;
    customDeliveryInvoiceNumber?: string | undefined;
    customerId?: number;
    customer?: Customer | undefined;
    date?: Date;
    deliveryInvoiceId?: number;
    deliveryInvoiceProducts?: CrudDeliveryInvoiceProductDto[] | undefined;
    invoiceIdentifier?: string;
    invoicePath?: string | undefined;
    invoicePaymentStatusId?: number;
    invoiceStatusId?: number;
    note?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    vat?: number;

    constructor(data?: ICrudDeliveryInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingId = _data["accountingId"];
            this.commercialId = _data["commercialId"];
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.customDeliveryInvoiceNumber = _data["customDeliveryInvoiceNumber"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.deliveryInvoiceId = _data["deliveryInvoiceId"];
            if (Array.isArray(_data["deliveryInvoiceProducts"])) {
                this.deliveryInvoiceProducts = [] as any;
                for (let item of _data["deliveryInvoiceProducts"])
                    this.deliveryInvoiceProducts!.push(CrudDeliveryInvoiceProductDto.fromJS(item));
            }
            this.invoiceIdentifier = _data["invoiceIdentifier"];
            this.invoicePath = _data["invoicePath"];
            this.invoicePaymentStatusId = _data["invoicePaymentStatusId"];
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.note = _data["note"];
            this.paymentTermId = _data["paymentTermId"];
            this.paymentTermNote = _data["paymentTermNote"];
            this.taxOnCash = _data["taxOnCash"];
            this.vat = _data["vat"];
        }
    }

    static fromJS(data: any): CrudDeliveryInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrudDeliveryInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingId"] = this.accountingId;
        data["commercialId"] = this.commercialId;
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["customDeliveryInvoiceNumber"] = this.customDeliveryInvoiceNumber;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["deliveryInvoiceId"] = this.deliveryInvoiceId;
        if (Array.isArray(this.deliveryInvoiceProducts)) {
            data["deliveryInvoiceProducts"] = [];
            for (let item of this.deliveryInvoiceProducts)
                data["deliveryInvoiceProducts"].push(item.toJSON());
        }
        data["invoiceIdentifier"] = this.invoiceIdentifier;
        data["invoicePath"] = this.invoicePath;
        data["invoicePaymentStatusId"] = this.invoicePaymentStatusId;
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["note"] = this.note;
        data["paymentTermId"] = this.paymentTermId;
        data["paymentTermNote"] = this.paymentTermNote;
        data["taxOnCash"] = this.taxOnCash;
        data["vat"] = this.vat;
        return data; 
    }
}

export interface ICrudDeliveryInvoiceDto {
    accountingId?: number;
    commercialId?: number;
    createdByUserId?: number;
    creationDate?: Date;
    customDeliveryInvoiceNumber?: string | undefined;
    customerId?: number;
    customer?: Customer | undefined;
    date?: Date;
    deliveryInvoiceId?: number;
    deliveryInvoiceProducts?: CrudDeliveryInvoiceProductDto[] | undefined;
    invoiceIdentifier?: string;
    invoicePath?: string | undefined;
    invoicePaymentStatusId?: number;
    invoiceStatusId?: number;
    note?: string | undefined;
    paymentTermId?: number;
    paymentTermNote?: string | undefined;
    taxOnCash?: number;
    vat?: number;
}

export class ExpenseKindDto implements IExpenseKindDto {
    expenseKindId?: number;
    name?: string | undefined;

    constructor(data?: IExpenseKindDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseKindId = _data["expenseKindId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExpenseKindDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseKindDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseKindId"] = this.expenseKindId;
        data["name"] = this.name;
        return data; 
    }
}

export interface IExpenseKindDto {
    expenseKindId?: number;
    name?: string | undefined;
}

export class ExpenseDto implements IExpenseDto {
    amount?: number;
    comment?: string | undefined;
    date?: Date;
    expenseId?: number;
    expenseKindId?: number;
    expenseKind?: ExpenseKindDto | undefined;

    constructor(data?: IExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.expenseId = _data["expenseId"];
            this.expenseKindId = _data["expenseKindId"];
            this.expenseKind = _data["expenseKind"] ? ExpenseKindDto.fromJS(_data["expenseKind"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["expenseId"] = this.expenseId;
        data["expenseKindId"] = this.expenseKindId;
        data["expenseKind"] = this.expenseKind ? this.expenseKind.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExpenseDto {
    amount?: number;
    comment?: string | undefined;
    date?: Date;
    expenseId?: number;
    expenseKindId?: number;
    expenseKind?: ExpenseKindDto | undefined;
}

export class ExpenseFilterDto implements IExpenseFilterDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    expenseKinds?: number[] | undefined;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;

    constructor(data?: IExpenseFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["expenseKinds"])) {
                this.expenseKinds = [] as any;
                for (let item of _data["expenseKinds"])
                    this.expenseKinds!.push(item);
            }
            this.accountingId = _data["accountingId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.stockId = _data["stockId"];
        }
    }

    static fromJS(data: any): ExpenseFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.expenseKinds)) {
            data["expenseKinds"] = [];
            for (let item of this.expenseKinds)
                data["expenseKinds"].push(item);
        }
        data["accountingId"] = this.accountingId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["stockId"] = this.stockId;
        return data; 
    }
}

export interface IExpenseFilterDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    expenseKinds?: number[] | undefined;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;
}

export class ExpenseDtoExpensePaginatedDto implements IExpenseDtoExpensePaginatedDto {
    totalAmount?: number;
    data?: ExpenseDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IExpenseDtoExpensePaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExpenseDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): ExpenseDtoExpensePaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseDtoExpensePaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface IExpenseDtoExpensePaginatedDto {
    totalAmount?: number;
    data?: ExpenseDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class FurnisherPaginatedDto implements IFurnisherPaginatedDto {
    data?: Furnisher[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IFurnisherPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Furnisher.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): FurnisherPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface IFurnisherPaginatedDto {
    data?: Furnisher[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class FurnisherInvoiceProductDto implements IFurnisherInvoiceProductDto {
    furnisherInvoiceProductId?: number;
    furnisherInvoiceId?: number;
    productId?: number;
    productName?: string | undefined;
    quantity?: number;
    description?: string | undefined;
    unitPrice?: number;
    discount?: number;

    constructor(data?: IFurnisherInvoiceProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherInvoiceProductId = _data["furnisherInvoiceProductId"];
            this.furnisherInvoiceId = _data["furnisherInvoiceId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): FurnisherInvoiceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherInvoiceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherInvoiceProductId"] = this.furnisherInvoiceProductId;
        data["furnisherInvoiceId"] = this.furnisherInvoiceId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        return data; 
    }
}

export interface IFurnisherInvoiceProductDto {
    furnisherInvoiceProductId?: number;
    furnisherInvoiceId?: number;
    productId?: number;
    productName?: string | undefined;
    quantity?: number;
    description?: string | undefined;
    unitPrice?: number;
    discount?: number;
}

export class FurnisherInvoiceDto implements IFurnisherInvoiceDto {
    furnisherInvoiceId?: number;
    creationDate?: Date;
    accountingId?: number;
    furnisherId?: number;
    currencyCode?: string | undefined;
    currencyId?: number;
    companyName?: string | undefined;
    note?: string | undefined;
    invoiceStatus?: string | undefined;
    invoiceStatusId?: string | undefined;
    stockId?: number | undefined;
    stockName?: string | undefined;
    date?: Date;
    furnisherInvoiceProducts?: FurnisherInvoiceProductDto[] | undefined;

    constructor(data?: IFurnisherInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherInvoiceId = _data["furnisherInvoiceId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.accountingId = _data["accountingId"];
            this.furnisherId = _data["furnisherId"];
            this.currencyCode = _data["currencyCode"];
            this.currencyId = _data["currencyId"];
            this.companyName = _data["companyName"];
            this.note = _data["note"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.invoiceStatusId = _data["invoiceStatusId"];
            this.stockId = _data["stockId"];
            this.stockName = _data["stockName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["furnisherInvoiceProducts"])) {
                this.furnisherInvoiceProducts = [] as any;
                for (let item of _data["furnisherInvoiceProducts"])
                    this.furnisherInvoiceProducts!.push(FurnisherInvoiceProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FurnisherInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherInvoiceId"] = this.furnisherInvoiceId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["accountingId"] = this.accountingId;
        data["furnisherId"] = this.furnisherId;
        data["currencyCode"] = this.currencyCode;
        data["currencyId"] = this.currencyId;
        data["companyName"] = this.companyName;
        data["note"] = this.note;
        data["invoiceStatus"] = this.invoiceStatus;
        data["invoiceStatusId"] = this.invoiceStatusId;
        data["stockId"] = this.stockId;
        data["stockName"] = this.stockName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.furnisherInvoiceProducts)) {
            data["furnisherInvoiceProducts"] = [];
            for (let item of this.furnisherInvoiceProducts)
                data["furnisherInvoiceProducts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFurnisherInvoiceDto {
    furnisherInvoiceId?: number;
    creationDate?: Date;
    accountingId?: number;
    furnisherId?: number;
    currencyCode?: string | undefined;
    currencyId?: number;
    companyName?: string | undefined;
    note?: string | undefined;
    invoiceStatus?: string | undefined;
    invoiceStatusId?: string | undefined;
    stockId?: number | undefined;
    stockName?: string | undefined;
    date?: Date;
    furnisherInvoiceProducts?: FurnisherInvoiceProductDto[] | undefined;
}

export class AmountDashboardDto implements IAmountDashboardDto {
    amount?: number;
    startPeriod?: Date;
    endPeriod?: Date;

    constructor(data?: IAmountDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.startPeriod = _data["startPeriod"] ? new Date(_data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = _data["endPeriod"] ? new Date(_data["endPeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AmountDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmountDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IAmountDashboardDto {
    amount?: number;
    startPeriod?: Date;
    endPeriod?: Date;
}

export class FurnisherInvoiceFilterDto implements IFurnisherInvoiceFilterDto {
    furnisherId?: number | undefined;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;

    constructor(data?: IFurnisherInvoiceFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherId = _data["furnisherId"];
            this.accountingId = _data["accountingId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.stockId = _data["stockId"];
        }
    }

    static fromJS(data: any): FurnisherInvoiceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherInvoiceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherId"] = this.furnisherId;
        data["accountingId"] = this.accountingId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["stockId"] = this.stockId;
        return data; 
    }
}

export interface IFurnisherInvoiceFilterDto {
    furnisherId?: number | undefined;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;
}

export class FurnisherInvoiceDtoPaginatedDto implements IFurnisherInvoiceDtoPaginatedDto {
    data?: FurnisherInvoiceDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IFurnisherInvoiceDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FurnisherInvoiceDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): FurnisherInvoiceDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherInvoiceDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface IFurnisherInvoiceDtoPaginatedDto {
    data?: FurnisherInvoiceDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class FurnisherDto implements IFurnisherDto {
    furnisherId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    companyName?: string | undefined;
    companyIdentificationNumber?: string | undefined;
    contact?: string | undefined;

    constructor(data?: IFurnisherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherId = _data["furnisherId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.companyName = _data["companyName"];
            this.companyIdentificationNumber = _data["companyIdentificationNumber"];
            this.contact = _data["contact"];
        }
    }

    static fromJS(data: any): FurnisherDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherId"] = this.furnisherId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["companyName"] = this.companyName;
        data["companyIdentificationNumber"] = this.companyIdentificationNumber;
        data["contact"] = this.contact;
        return data; 
    }
}

export interface IFurnisherDto {
    furnisherId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    companyName?: string | undefined;
    companyIdentificationNumber?: string | undefined;
    contact?: string | undefined;
}

export class CrudFurnisherInvoiceProductDto implements ICrudFurnisherInvoiceProductDto {
    furnisherInvoiceProductId?: number;
    furnisherInvoiceId?: number;
    productId?: number;
    productName?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    isNewProduct?: boolean;

    constructor(data?: ICrudFurnisherInvoiceProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherInvoiceProductId = _data["furnisherInvoiceProductId"];
            this.furnisherInvoiceId = _data["furnisherInvoiceId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.isNewProduct = _data["isNewProduct"];
        }
    }

    static fromJS(data: any): CrudFurnisherInvoiceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrudFurnisherInvoiceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherInvoiceProductId"] = this.furnisherInvoiceProductId;
        data["furnisherInvoiceId"] = this.furnisherInvoiceId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["isNewProduct"] = this.isNewProduct;
        return data; 
    }
}

export interface ICrudFurnisherInvoiceProductDto {
    furnisherInvoiceProductId?: number;
    furnisherInvoiceId?: number;
    productId?: number;
    productName?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    isNewProduct?: boolean;
}

export class CrudFurnisherInvoiceDto implements ICrudFurnisherInvoiceDto {
    furnisherInvoiceId?: number;
    furnisherId?: number;
    stockId?: number | undefined;
    note?: string | undefined;
    date?: Date;
    accountingId?: number;
    currencyId?: number;
    furnisher?: FurnisherDto | undefined;
    furnisherInvoiceProducts?: CrudFurnisherInvoiceProductDto[] | undefined;

    constructor(data?: ICrudFurnisherInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherInvoiceId = _data["furnisherInvoiceId"];
            this.furnisherId = _data["furnisherId"];
            this.stockId = _data["stockId"];
            this.note = _data["note"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.accountingId = _data["accountingId"];
            this.currencyId = _data["currencyId"];
            this.furnisher = _data["furnisher"] ? FurnisherDto.fromJS(_data["furnisher"]) : <any>undefined;
            if (Array.isArray(_data["furnisherInvoiceProducts"])) {
                this.furnisherInvoiceProducts = [] as any;
                for (let item of _data["furnisherInvoiceProducts"])
                    this.furnisherInvoiceProducts!.push(CrudFurnisherInvoiceProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrudFurnisherInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrudFurnisherInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherInvoiceId"] = this.furnisherInvoiceId;
        data["furnisherId"] = this.furnisherId;
        data["stockId"] = this.stockId;
        data["note"] = this.note;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["accountingId"] = this.accountingId;
        data["currencyId"] = this.currencyId;
        data["furnisher"] = this.furnisher ? this.furnisher.toJSON() : <any>undefined;
        if (Array.isArray(this.furnisherInvoiceProducts)) {
            data["furnisherInvoiceProducts"] = [];
            for (let item of this.furnisherInvoiceProducts)
                data["furnisherInvoiceProducts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICrudFurnisherInvoiceDto {
    furnisherInvoiceId?: number;
    furnisherId?: number;
    stockId?: number | undefined;
    note?: string | undefined;
    date?: Date;
    accountingId?: number;
    currencyId?: number;
    furnisher?: FurnisherDto | undefined;
    furnisherInvoiceProducts?: CrudFurnisherInvoiceProductDto[] | undefined;
}

export class PaymentDto implements IPaymentDto {
    paymentId?: number;
    creationDate?: Date;
    date?: Date;
    comment?: string | undefined;
    paymentTermNote?: string | undefined;
    paidBy?: string | undefined;
    companyName?: string | undefined;
    amount?: number;
    paymentTermId?: number;
    accountingId?: number;
    customerId?: number;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.paymentTermNote = _data["paymentTermNote"];
            this.paidBy = _data["paidBy"];
            this.companyName = _data["companyName"];
            this.amount = _data["amount"];
            this.paymentTermId = _data["paymentTermId"];
            this.accountingId = _data["accountingId"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["paymentTermNote"] = this.paymentTermNote;
        data["paidBy"] = this.paidBy;
        data["companyName"] = this.companyName;
        data["amount"] = this.amount;
        data["paymentTermId"] = this.paymentTermId;
        data["accountingId"] = this.accountingId;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IPaymentDto {
    paymentId?: number;
    creationDate?: Date;
    date?: Date;
    comment?: string | undefined;
    paymentTermNote?: string | undefined;
    paidBy?: string | undefined;
    companyName?: string | undefined;
    amount?: number;
    paymentTermId?: number;
    accountingId?: number;
    customerId?: number;
}

export class PaymentFilterDto implements IPaymentFilterDto {
    customerId?: number | undefined;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;

    constructor(data?: IPaymentFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.accountingId = _data["accountingId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.stockId = _data["stockId"];
        }
    }

    static fromJS(data: any): PaymentFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["accountingId"] = this.accountingId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["stockId"] = this.stockId;
        return data; 
    }
}

export interface IPaymentFilterDto {
    customerId?: number | undefined;
    accountingId?: number | undefined;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    stockId?: number | undefined;
}

export class PaymentDtoPaginatedDto implements IPaymentDtoPaginatedDto {
    data?: PaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IPaymentDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PaymentDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): PaymentDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface IPaymentDtoPaginatedDto {
    data?: PaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class SmallProductDtoPaginatedDto implements ISmallProductDtoPaginatedDto {
    data?: SmallProductDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: ISmallProductDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SmallProductDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): SmallProductDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmallProductDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data; 
    }
}

export interface ISmallProductDtoPaginatedDto {
    data?: SmallProductDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}